import type { FC } from 'react';
import { lazy } from 'react';
import { useParams } from 'react-router';
import { useOptionalDocumentExchangeRoot } from 'src/apis/document-exchange/use-document-exchange-root';
import { PageSpinner } from 'src/components/spinner-container';
import { Forbidden } from 'src/utils/errors';

const Page = lazy(() => import('./page'));

export const EditShipperDocument: FC = () => {
  const documentExchange = useOptionalDocumentExchangeRoot();

  const { operatorDocumentId } = useParams<{ operatorDocumentId: string }>();

  if (!documentExchange.loaded) return <PageSpinner />;

  if (!documentExchange.response) throw new Forbidden();

  const { shippers, uploadFile, operatorDocument } =
    documentExchange.response.data._links;

  if (!shippers || !uploadFile || !operatorDocument) throw new Forbidden();

  return (
    <Page
      documentId={operatorDocumentId}
      documentLink={operatorDocument.href}
      shippersLink={shippers.href}
      uploadDocumentLink={uploadFile.href}
    />
  );
};
